/***
 * @file:
 * @author: caojianping
 * @Date: 2021-02-25 19:12:51
 */

import { Component, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { SettingsService, StoreService } from '@ithinkdt/shared/browser';
import { UrlChangeService } from '@ithinkdt/shared/route';
import { ThemeConfig } from '@ithinkdt/theme/models';

@Component({
  selector: 'dt-pcp-theme',
  templateUrl: './pcp-theme.component.html',
  styleUrls: ['./pcp-theme.component.scss'],
})
export class PcpThemeComponent implements OnInit, OnChanges, OnDestroy {
  routeChange: Subscription; // è·¯ç±æ¹åsub

  themeConfig: ThemeConfig; // ä¸»é¢éç½®
  isCollapsed = true; // æ¯å¦å±å¼

  constructor(
    private router: Router,
    private settingSrv: SettingsService,
    private urlChangeSrv: UrlChangeService,
    private storeSrv: StoreService
  ) {
    this.initData();
    this.jumpRouter();
  }

  ngOnChanges(changes: SimpleChanges): void {}

  ngOnInit() {}

  ngOnDestroy() {
    if (this.routeChange) {
      this.routeChange.unsubscribe();
      this.routeChange = null;
    }
  }

  // åå§åæ°æ®
  initData() {
    this.themeConfig = this.settingSrv.userConfig['theme'] || {};
    this.setHideMenu();
    this.isCollapsed = this.themeConfig.hidenMenu === true;
  }

  // è®¾ç½®æ¯å¦æ¾ç¤ºèå
  setHideMenu() {
    const hideMenuParam = this.urlChangeSrv.getParam('hideMenu');
    if (hideMenuParam) {
      this.settingSrv.setHideMenu(hideMenuParam);
    }

    const hideMenu = this.settingSrv.hideMenu;
    if (hideMenuParam || hideMenu) {
      this.themeConfig.hidenMenu = true;
    }
  }

  // è·³è½¬è·¯ç±
  jumpRouter() {
    const url = this.storeSrv.get('jumpRouter');
    if (!url) {
      return;
    }

    const route = url.slice(0, url.indexOf('?'));
    const param = url.slice(url.indexOf('?') + 1, url.length);
    const params = {};
    const arr = param.split('&');
    arr.forEach((item) => {
      const key = item.split('=')[0];
      const val = item.split('=')[1];
      if (key !== 'jumpToken') {
        params[key] = val;
      }
    });

    setTimeout(() => {
      this.router.navigate([route], { queryParams: params });
    });
  }

  // åæ¢ä¾§è¾¹æ 
  toggleSider() {
    this.isCollapsed = !this.isCollapsed;
  }
}
